
import { Button, Card, CardContent, Chip, FormGroup, FormLabel, GridLegacy as Grid, IconButton, Input, InputAdornment, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import dayjs from '../../../utils/dayjs-setup';
import { useState,useEffect, useContext } from "react";
import { DatePickerInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString,  DialogType,  EstadosItemsAlistamiento,  EstadosPedido,  FormActions, FormatPrice, getStatusPedido, usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { FilterForm } from "../../../components/form/filter-form";
import { useNavigate, useParams } from "react-router-dom";
import { Save } from "@mui/icons-material";
import { grey, red } from "@mui/material/colors";
import { CustomDialog } from "../../../components/modals/custom-dialog";




const ItemListPedido = (props)=>{
  
  const [cantidadLocal,setCantidadLocal] = useState(props.cantidad_inv);

  const saveChanges = ()=>{
    props.onChangeValue(props.index_item,props.subindex,cantidadLocal,props.estado);
    
  }
  console.log({
    cantidad_inv:props.cantidad_inv,
    cantidadLocal,
    disabled:Number(props.cantidad_inv) === cantidadLocal,
    estado:props.estado
  });
  const hasDisabled = ["",null].includes(cantidadLocal)? true: (props.cantidad_inv === cantidadLocal) ;
  console.log({hasDisabled});
  return (  
    <Card>
      <CardContent>
      <Typography sx={{ fontSize: 15 }} color="text.primary" gutterBottom>
          <strong>REF:</strong> {props.referencia}
      </Typography>
      <Typography sx={{ fontSize: 14 }} color="text.primary" gutterBottom>
          <strong>PRODUCTO:</strong> {props.nombre_producto}
      </Typography>
     
      <Typography sx={{ fontSize: 14 }} color="text.primary" gutterBottom>
          <strong>SOLICITADO</strong> {FormatPrice(props.cantidad,2)} {props.cod_erp_unidad_medida}
      </Typography>
       
       <Stack direction={"row"} alignItems={"center"} >
       <FormGroup sx={{marginBottom:'5px',width:'70%'}} >
         <FormLabel>ALISTADO</FormLabel>
         <Input onChange={e=>setCantidadLocal(e.target.value)} 
         type="number"
         inputProps={{style:{textAlign:"center"}}} 
         value={ [null,''].includes(cantidadLocal)?'':Number(cantidadLocal)} 
         endAdornment={<InputAdornment
         position="end"
         
         >
          {props.cod_erp_unidad_medida}
         </InputAdornment>} />
         
       </FormGroup>
       <IconButton disabled={ hasDisabled} onClick={saveChanges} style={{width:'32px',height:'32px',color:"white",background:hasDisabled?grey[500]:red[500],marginLeft:'10px'}}  > <Save /></IconButton>
       </Stack>
      
       <Chip size="small" color={EstadosItemsAlistamiento[props.estado]?.color} label={EstadosItemsAlistamiento[props.estado]?.label} />


      </CardContent>
    </Card>

  )

}




const CardResumeBuild = ({
  title="",
  label_numer="",
  extraLabel=""
})=>(
  <Card >
      <CardContent>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="h5" component="div">
          {label_numer}
        </Typography>
       <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {extraLabel}
        </Typography> 
      
      </CardContent>
{/*       <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions> */}
    </Card>
)

const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  fecha_entrega:dayjs(),
};

const schemaFilter = yup.object({
  

}).required();

export const DetalleAlistamiento = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store:{profile}} = useContext( AppContext );
  const [pedidoInfo,setPedidoInfo] = useState({});
  const [internalDialog,setInternalDialog] = useState({});
  const {cod_pedido} = useParams();
  const navigate = useNavigate();
  const configuracionApp = profile.configuracion_comp?JSON.parse(profile.configuracion_comp):{};

    useEffect(()=>{

      
      loadInitData();

    },[]);
    



    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
     await loadItems(false);
     
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }


/*   const  setFilterAply = (filtros)=>{
    console.log({filtros});

    setFilterSearchPagination({
      ...filterSearchPagination,
      ...filtros
    });
  }
 */
    const loadItems =  async (loading=true,filtros=filterSearchPagination)=>{
      console.log({filtros,filterSearchPagination});
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }
    
     let {data:{value}} = await AxiosInstance.post("maestros-marketplace/get-pedido-alistamiento",{
      cod_pedido
     });

     const copyDetalle = [...value.detalle_pedido];
     const newList = [];
       
     copyDetalle.forEach( item_det =>{
      if ( String(item_det.cod_erp_producto).trim() === configuracionApp.CREACION_PEDIDOS.item_domicilio ){
        return;
      }
      const indProd = newList.findIndex( item_new =>item_new.cod_uen === item_det.cod_erp_unidad_negocios );
      if ( indProd !== -1 ){
        newList[indProd].lista.push(item_det);
      }else{
        newList.push({
          cod_uen:item_det.cod_erp_unidad_negocios,
          lista:[item_det]
        });
      }
     } );
     console.log({newList});
     value.detalle_pedido = newList;
     
     setPedidoInfo({
      ...value
     });

     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
     });
   
    }

    const onChageValueAlistamiento = (parent_index,child_index,value,estado)=>{
   
        let newPedido = {...pedidoInfo};
        newPedido.detalle_pedido[parent_index].lista[child_index].cantidad_inv = value;
        setPedidoInfo({
          ...newPedido
        });
        onChangeQantity(newPedido.detalle_pedido[parent_index].lista[child_index].cod,value,getStatusPedido({
          cantidad:newPedido.detalle_pedido[parent_index].lista[child_index].cantidad,
          cantidad_inv:newPedido.detalle_pedido[parent_index].lista[child_index].cantidad_inv
        }));
    }

    const onChangeQantity = async(cod_detalle_pedido,cantidad,estado)=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
       });
       try{
        let {data:{value}} = await AxiosInstance.post("maestros-marketplace/actualizar-cantidades-alistamiento",{
          cod_detalle_pedido,
          cantidad_inv:cantidad,
          estado
         });
       }catch(e){
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Error",
              message:"Verifique su conexion a internet",
              type:DialogType.peligro,
              isVisible:true
          }
      });
       }

       dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
       });
    }

  
    const columnsTable = [
       {
      
       key:"pedido_item",
       keyValue:"pedido_item",
       label:"",
       headerRender:(props)=>props.label,
       bodyRender:({info})=><ItemListPedido  onChangeValue={onChageValueAlistamiento} onChangeStatusPedido={ estatus=>CambiarEstadoPedido(info,estatus)} {...info} />,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      }
     
     
       
 
    ];
  
    const CambiarEstadoPedido = (pedidoData,status)=>{

   
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });

        AxiosInstance.post("maestros-marketplace/update-status-pedido",{
          cod_pedido:pedidoData.cod,
          action:"ALISTADO"
        }).then(  ({data})=>{

          setInternalDialog({
            isOpened:true,
            title:'Proceso finalizado',
            content:`EL proceso de alistamiento finalizo correctamente`,
            actions:[
             
              {
                buttomProps:{
                 variant:"contained",
                 size:"small",
                 color:"success",
                 onClick:()=>{
                  setInternalDialog({});
                  window.history.back();
                 }
              },
              title:"OK"
            },
            ]
           });
    
      

        }).catch(error=>{

          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Ocurrio un error al tratar de finalizar el alistamiento",
                type:DialogType.peligro,
                isVisible:true
            }
        });

        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });

    
    }




    let total_productos = 0;
    let productos_alistados =  0;
    let alistados_con_novedad =  0;
     pedidoInfo.detalle_pedido?.forEach( item=>{
       total_productos+= item.lista.length;
       item.lista.forEach( sub_item=>{
          if(  ![null,''].includes( sub_item.cantidad_inv )  ){
           productos_alistados += 1; 
          }
 
          if ( Number( sub_item.cantidad_inv ) < Number(sub_item.cantidad) && Number( sub_item.cantidad_inv ) > 0 ){
            alistados_con_novedad +=1;
          }
          if ( Number( sub_item.cantidad_inv ) > Number(sub_item.cantidad) && Number( sub_item.cantidad_inv ) > 0 ){
            alistados_con_novedad +=1;
          }
       } );
     } );
     console.log({alistados_con_novedad});



     

     const onFinalizarAlistamiento  = ()=>{
      let errorText = "";

      pedidoInfo.detalle_pedido.forEach(uenList =>{
        
        uenList.lista.forEach( item_prod=>{
          const estado = getStatusPedido({cantidad:item_prod.cantidad,cantidad_inv:item_prod.cantidad_inv});
          console.log("my status",estado,item_prod.cantidad,item_prod.cantidad_inv);
          if ( estado === 'PENDIENTE' ){
            errorText = errorText+`<strong>**</strong> ${item_prod.nombre_producto} </br>`;
          }

        } );

      });
      console.log({errorText});
     if ( errorText.length > 0  ){
        errorText = `Los siguientes items no han sido gestionados:</br></br>${errorText}`;
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Items sin alistar",
              message:errorText,
              type:DialogType.peligro,
              isVisible:true
          }
      });
      return;
      } 

      if ( alistados_con_novedad > 0){

         setInternalDialog({
          isOpened:true,
          title:'Confirmar accion',
          content:`Algunos items tienen novedades con el alistamiento <b>${alistados_con_novedad}/${total_productos} </b>:</br></br>¿Desea finalizar la fase de alistamiento?`,
          actions:[
          
            {
              buttomProps:{
               variant:"contained",
               size:"small",
               color:"error",
               onClick:()=>{
                setInternalDialog({});
               }
            },
            title:"NO"},
            {
              buttomProps:{
               variant:"contained",
               size:"small",
               color:"success",
               onClick:()=>{
                setInternalDialog({});
                CambiarEstadoPedido(pedidoInfo);
               }
            },
            title:"SI, FINALIZAR"},
          ]
         });

         return;

      }

      CambiarEstadoPedido(pedidoInfo);

     }

    
  

    return (<>
   
   <CustomDialog
   {...internalDialog}
    />
   
    <Grid container spacing={2} >
   
        <Grid spacing={1} container item sm={12} xs={12} md={12} >
        <Grid  item sm={12} xs={12} md={12}  >
        <Typography variant="h6" >PEDIDO ID : {cod_pedido}</Typography>
        </Grid>
          <Grid  item sm={12} xs={12} md={12}  >
          <Card  >
              <CardContent>
                <Typography variant="h6" >Datos del vendedor</Typography>
                <Typography variant="subtitle2" ><strong>NOMBRE:</strong>{pedidoInfo.vendedor?pedidoInfo.vendedor:'ACERCATE'}</Typography>
                <Typography variant="subtitle2" ><strong>TEL:</strong>  {pedidoInfo.vendedor_celular?pedidoInfo.vendedor_celular:'N/A'}</Typography>
                <Typography variant="subtitle2" ><strong>CORREO:</strong>  {pedidoInfo.vendedor_correo?pedidoInfo.vendedor_correo:'N/A'}</Typography>
              </CardContent>
          </Card>
          </Grid>
          <Grid  item sm={12} xs={12} md={12}  >
          <Card  >
              <CardContent>
                <Typography variant="h6" >Estado general</Typography>
                <Typography variant="subtitle2" ><strong>Cliente : </strong> {pedidoInfo.nombre_cliente}</Typography>
                 <Stack direction={"row"} >
                 <Typography variant="subtitle2" ><strong>Estado del pedido : </strong></Typography>
                 <Chip size="small" color={EstadosPedido[pedidoInfo.estado_nombre]?.color} label={`${EstadosPedido[pedidoInfo.estado_nombre]?.label}`} />
                 </Stack>
                <Typography variant="subtitle2" ><strong>Items Alistados :</strong>{`${productos_alistados} de ${total_productos} items`}</Typography>
                <Typography variant="subtitle2" ><strong>Alistado con novedad :</strong>{`${alistados_con_novedad} items`}</Typography>
                
              </CardContent>
          </Card>
          </Grid>
          <Grid item sm={12} xs={12} md={12} >
           <Button onClick={onFinalizarAlistamiento} variant="contained" size="small" color="primary" >Finalizar alistamiento</Button>
        </Grid>
        
          
        </Grid>

        <Grid item sm={12} xs={12} md={12} >
          <Typography variant="h6" >
              Listado de items
          </Typography>
        </Grid>
        
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer >
               <Table >
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
                 {pedidoInfo.detalle_pedido?.map( (item,index_item)=>[
                   <TableRow key={item.cod_uen} >
                   <TableCell> <strong>UEN {item.cod_uen}</strong> </TableCell>
                  </TableRow>,
                  item.lista.map((item_list,subindex)=>  <TableRow key={item_list.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell key={`${item.cod_uen}-${item_list.cod}`}  >
                          {<Col.bodyRender    info={{...item_list,index_item,subindex,estado:getStatusPedido(item_list)}} value={{...item_list,index_item,subindex,estado:getStatusPedido(item_list)}} />}
                       </TableCell>)
                    }

                  </TableRow>)
                  
                 ])}
               
              
            </TableBody>
           
          </Table>
          </TableContainer>
       

        </Grid>
    </Grid>
    </>)

}